import { ActivatedRouteSnapshot } from '@angular/router';
import { IChangesGuardedComponent } from '../../interfaces/changes-guarded-component.interface';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TabSheetsService } from 'src/app/shared/services/tab-sheets.service';
import { UnsavedChangesProxyService } from 'src/app/shared/services/unsaved-changes-proxy.service';

@Injectable()
export class UnsavedChangesGuard {
  constructor(
    private readonly unsavedChangesProxyService: UnsavedChangesProxyService,
    private readonly tabSheetsService: TabSheetsService
  ) {}

  public canDeactivate(component: IChangesGuardedComponent, currentRoute: ActivatedRouteSnapshot): Observable<boolean> {
    if (component === null) {
      const componentToDeactivate = currentRoute.data?.componentToDeactivate;

      if (componentToDeactivate) {
        component = this.tabSheetsService.components.find((x) => x instanceof componentToDeactivate);
      }
    }

    if (component?.confirmed) {
      return of(true);
    }

    if (component?.hasUnsavedChanges()) {
      const confirmCallback = () => {
        component.confirmed = true;
        component.confirmCallback?.();
      };

      return this.unsavedChangesProxyService.showModal(
        () => confirmCallback(),
        () => component.rejectCallback?.()
      );
    }

    return of(true);
  }
}
